module.exports = __webpack_public_path__ + "img/plate_stopped.fa167a4d.svg";